// extracted by mini-css-extract-plugin
export default {"Text":"repository-renderer-module__Text--JHUu7"};